import { useEffect, useState } from "react";

import { useDropdownSourceContext } from "@ryde/redux";
import { BulkProduceTypeEnum, IDropdownItemProduceButtons } from "@ryde/shared";

interface IUseNextButtonProductionAction {
  productionAction?: BulkProduceTypeEnum;
}

export const useNextButtonProductionAction = (
  produceButtonId?: number | string,
): IUseNextButtonProductionAction => {
  const { getDropdownItems } = useDropdownSourceContext();
  const [productionAction, setProductionAction] = useState<
    BulkProduceTypeEnum | undefined
  >();

  useEffect(() => {
    let isCanceled = false;

    const resolveProductionAction = async (): Promise<void> => {
      if (!produceButtonId) {
        if (!isCanceled) {
          setProductionAction(undefined);
        }

        return;
      }

      const items = (await getDropdownItems(
        "produceButton",
      )) as IDropdownItemProduceButtons[];
      const selectedButton = items?.find(
        item => Number(item.value) === Number(produceButtonId),
      );

      if (!isCanceled) {
        setProductionAction(selectedButton?.productionAction);
      }
    };

    resolveProductionAction();

    return () => {
      isCanceled = true;
    };
  }, [getDropdownItems, produceButtonId]);

  return { productionAction };
};
